<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="Company Preference"
            />
        </div>

        <section id="basic-tabs-components">
            <div class="row match-height">
                <div class="col-12">
                    <div class="card" style="min-height: 400px;">
                        <div class="card-body">
                            <div class="d-flex align-items-start">
                                <ul
                                    class="nav flex-column nav-pills me-2 pe-2 border-end bg-white rounded-3 sidebar-tabs pt-1"
                                    role="tablist"
                                    style="min-height: 300px"
                                    aria-orientation="vertical"
                                >
                                    <li v-for="tab in tabs" :key="tab.id" class="nav-item mb-1">
                                        <a
                                            href="#"
                                            :class="['nav-link', { active: activeTabId === tab.id }]"
                                            @click.prevent="setActiveTab(tab)"
                                        >
                                            {{ tab.title }}
                                        </a>
                                    </li>
                                </ul>

                                <div class="flex-grow-1">
                                    <component
                                        :is="activeTab"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {onMounted, ref, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import AccountingSettings from "@/components/molecule/company/company-preference/AccountingSettings.vue";
import BillingSettings from "@/components/molecule/company/company-preference/BillingSettings.vue";

const route = useRoute();
const router = useRouter();
const loading = ref(false)

const activeTab = ref(AccountingSettings)
const activeTabId = ref("accounting-settings")
const tabs = [
    {id: 'accounting-settings', title: 'Accounting Settings', component: AccountingSettings},
    {id: 'billing-settings', title: 'Billing Settings', component: BillingSettings},
]

const setActiveTab = (tab) => {
    router.replace({query: {...route.query, tab: tab.id}})
}

onMounted(() => {
    const tabFromUrl = route.query.tab
    if (tabFromUrl && tabs.find(t => t.id === tabFromUrl)) {
        activeTabId.value = tabFromUrl
        activeTab.value = tabs.find(t => t.id === tabFromUrl).component
    }
})

watch(() => route.query.tab, (newTab) => {
    if (newTab && tabs.find(t => t.id === newTab)) {
        activeTabId.value = newTab
        activeTab.value = tabs.find(t => t.id === newTab).component
    }
})

</script>

<style scoped>
.head td {
    text-align: right;
}
</style>